<template>
  <div>
    <div class="text-danger" v-if="showNoDataMessage && !isDiskHeadersLoading">
      {{ $t('grid.widgets.alarms.table.no_data') }}
    </div>

    <b-row v-if="!disksTabs.length && isDiskHeadersLoading">
      <b-col
        cols="4"
        v-for="(loading, index) in 2"
        md="3"
        :key="index">
        <SkeletonLoading :width="140" :height="37"/>
      </b-col>
    </b-row>

    <b-tabs>
      <b-tab
        :title="mainDisk.Name"
        :active="index == 0 ? true : false"
        v-for="(mainDisk, index) in disksTabs"
        :key="index"
        lazy
        @click="getDiskInfo(mainDisk.Index)"
      >
      <div v-if="!isDisksInfoLoading && deviceInfo && diskStatus" class="mb-1">
        <h6>{{ $t("hanwha_dvr.details") }}</h6>
        <div class="">
          <div class="d-flex">
            <div class="diskInfoDetailKey">Status</div>
            <div :style="{ color: diskStatus.color }">{{ diskStatus.value }}</div>
          </div>
          <div v-for="(detail, index) in deviceInfo" :key="index" class="d-flex">
            <div class="diskInfoDetailKey">{{ index }}</div>
            <div class="diskInfoDetailItem">{{ detail }}</div>
          </div>
        </div>
      </div>
      <div class="" v-if="!isDisksInfoLoading && disksInfo[mainDisk.Index]">
        <h6>{{ $t("hanwha_dvr.information") }}</h6>
        <b-table small :items="disksInfo[mainDisk.Index]" :fields="fields">
        </b-table>
      </div>
      <div v-if="isDisksInfoLoading">
        <SkeletonLoading :width="180" :height="55"/>
        <SkeletonLoading :width="220" :height="85"/>
      </div>
      <div class="text-danger" v-if="!disksInfo[mainDisk.Index] && !isDisksInfoLoading">
      {{ $t('grid.widgets.alarms.table.no_data') }}
      </div>
      </b-tab>
    </b-tabs>

  </div>
</template>

<script>
import { BModal, BSpinner } from "bootstrap-vue";
import { onMounted, ref } from "@vue/composition-api";
import vSelect from "vue-select";
// import { useDeviceInfo } from "./useDeviceInfo";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import { useDiskInfo } from "./useDiskInfo";

export default {
  components: {
    BModal,
    BSpinner,
    vSelect,
    SkeletonLoading
  },
  props: {
    hanwhaDvr: { type: Object, required: true }
  },
  setup(props, { emit }) {
    onMounted(() => getDisksInfo());

    const isModalActive = ref(false);
    const {
      getDisksInfo,
      getDiskInfo,
      disksTabs,
      isDiskHeadersLoading,
      showNoDataMessage,
      disksInfo,
      isDisksInfoLoading,
      deviceInfo,
      diskStatus,
      fields
    } = useDiskInfo(props.hanwhaDvr)


    const closeModal = () => {
      emit('close-modal');
    };

    return {
      isModalActive,
      disksTabs,
      isDiskHeadersLoading,
      showNoDataMessage,
      disksInfo,
      isDisksInfoLoading,
      deviceInfo,
      diskStatus,
      fields,
      closeModal,
      getDiskInfo
    };
  },
};
</script>

<style lang="scss" scoped>
.diskInfoDetailKey {
  width: 140px;
  font-weight: 100;
  color: #a5a5a5;
}
.diskInfoDetailItem {
  color: #393735;
}
.dark-layout {
  .diskInfoDetailKey {
    color: #a5a5a5;
  }
  .diskInfoDetailItem {
    color: #fff;
  }
}
</style>
